import * as Models from "../.";
export interface IGroupedTransactionRequest {
  igsCustomerNumber: string;
  skip: number;
  take: number;
  beginDate?: Date;
}

export class GroupedTransactionRequest implements IGroupedTransactionRequest {
  igsCustomerNumber: string;
  skip: number;
  take: number;
  beginDate?: Date;

  constructor(
    igsCustomerNumber: string,
    skip: number,
    take: number,
    beginDate?: Date
  ) {
    this.igsCustomerNumber = igsCustomerNumber;
    this.skip = skip;
    this.take = take;
    this.beginDate = beginDate;
  }
}

export interface ISortableTransactionSet {
  transactionSet: ITransactionSet;
  sortProperty: string;
  shouldReverseSort: boolean;

  sortBy: (propertyName: string) => void;
}

export class SortableTransactionSet implements ISortableTransactionSet {
  transactionSet: ITransactionSet;
  sortProperty = "completionDate";
  shouldReverseSort = true;

  constructor(transactionSet: ITransactionSet) {
    this.transactionSet = transactionSet;
  }

  public sortBy = (propertyName: string) => {
    this.shouldReverseSort =
      this.sortProperty === propertyName ? !this.shouldReverseSort : true;
    this.sortProperty = propertyName;
  };
}

export interface IGroupedTransactionResponse {
  transactionSets: ITransactionSet[];
  count: number;
}

export class GroupedTransactionResponse {
  transactionSets: ITransactionSet[];
  count: number;
}

export interface ITransactionSet {
  invoiceNumber: string;
  balanceDue: number;
  pastDue: number;
  otherCharges: number;
  formattedSendDate: string;
  formattedDueDate: string;
    transactions: Models.Customer.Transaction.ITransaction[];
    documentKey: string;
}

export class TransactionSet implements ITransactionSet {
  invoiceNumber: string;
  balanceDue: number;
  pastDue: number;
  otherCharges: number;
  formattedSendDate: string;
  formattedDueDate: string;
    transactions: Models.Customer.Transaction.ITransaction[];
    documentKey: string;
}
